import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { PageHeader } from "../../shared/ui";
import ModalConfirm from '../../shared/ui/modal-confirm/ui/ModalConfirm';
import Filter from '../../shared/ui/filter/Filter';

import { useLeadRequestsFilters } from '../../widgets/lead-requests-list/config/filter';
import LeadRequestsList from '../../widgets/lead-requests-list/ui/LeadRequestsList';
import { getAdminLeadRequests } from '../../shared/api/lead-requests.services';
import { buildListQuery, buildPaginationMeta } from '../../shared/lib/buildListQuery';

export default function ClientsPage() {
  const location = useLocation();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const leadRequestsFilters = useLeadRequestsFilters();

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const params = Object.fromEntries(new URLSearchParams(location.search).entries());
      // Пошук і фільтри виконує сервер: заявок може стати багато, і гортати
      // їх сторінками правильніше, ніж тягнути всі одразу.
      const { query, page, limit } = buildListQuery(params, {
        extraKeys: ['formType', 'status', 'source'],
      });

      const result = await getAdminLeadRequests(query);

      setData({
        ...result,
        meta: buildPaginationMeta({ page, limit, total: result?.total }),
      });
    } catch (error) {
      console.error('Помилка при завантаженні даних:', error);
    } finally {
      setLoading(false);
    }
  }, [location.search]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
      <ModalConfirm title="Ви впевнені, що хочете видалити цю заявку?" />

      <PageHeader
        placeholder={'Пошук за імʼям, телефоном, поштою або текстом'}
        filters={leadRequestsFilters}
      />
      <Filter fields={leadRequestsFilters} />

      <section className="section-admin">
        {loading ? (
          <p>Завантаження...</p>
        ) : (
          <LeadRequestsList data={data} onRefresh={fetchData} />
        )}
      </section>
    </>
  );
}
